var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-card",
        {
          staticClass: "md-card q-mt-lg q-pa-lg relative-position",
          attrs: { color: "white", "text-color": "black" }
        },
        [
          _c("q-card-title", [_vm._v("\n      AGC MN Dashboard\n    ")]),
          _c("q-card-separator"),
          _c("q-card-main", [
            _c("div", { staticClass: "row q-mb-lg" }, [
              _c(
                "div",
                { staticClass: "col-6 q-pr-sm" },
                [
                  _c(
                    "q-list",
                    { attrs: { highlight: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "check_box", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/pending-approval"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View Company Applications and Edits Pending\n                  Approval\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "business", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/company/list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View/Manage Companies\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "link", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/company/registrationLink"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Create Registration Link\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6 q-pl-sm" },
                [
                  _c(
                    "q-list",
                    { attrs: { highlight: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "people", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/person/list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View/Manage People\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "email", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/person/constant-contact"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Send Profile Update Email (Constant\n                  Contact)\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: {
                                  icon: "account_circle",
                                  color: "primary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/user/list"
                                  }
                                },
                                [_vm._v(" View/Manage Users\n                ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6 q-pr-sm" },
                [
                  _c(
                    "q-list",
                    { attrs: { highlight: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: {
                                  icon: "event_available",
                                  color: "primary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/event/list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View/Manage Events\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: { icon: "archive", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/contract/list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View/Manage Contracts\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6 q-pl-sm" },
                [
                  _c(
                    "q-list",
                    { attrs: { highlight: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: {
                                  icon: "attach_money",
                                  color: "primary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/purchase/list"
                                  }
                                },
                                [
                                  _vm._v(
                                    " View/Manage Purchases\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            [
                              _c("q-item-tile", {
                                attrs: {
                                  icon: "account_balance",
                                  color: "primary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    color: "primary",
                                    to: "/quickbooks"
                                  }
                                },
                                [
                                  _vm._v(
                                    " Find Helpful Quickbooks Links\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }